module.exports = __webpack_public_path__ + "img/spjk.b98e2f47.png";